import { PayrollView } from '../../../../types/entity-types';
import { PayrollTable } from '../../components/payrolls-table/payroll-table';
import { usePayrollFlow } from '../../use-payroll-flow';

type PayrollTabWrapperProps = {
  payrollFlow: ReturnType<typeof usePayrollFlow>;
  payrolls: PayrollView[];
};

const PayrollTabWrapper = ({ payrollFlow, payrolls }: PayrollTabWrapperProps) => {
  const { updatePayrollAction, viewExistingPayroll } = payrollFlow;

  return (
    <div className="-mt-14 pb-4">
      <PayrollTable
        payrolls={payrolls}
        handleNewPayroll={() => {
          updatePayrollAction('PAYROLL_SETUP');
        }}
        onSelectPayroll={viewExistingPayroll}
      />
    </div>
  );
};

export default PayrollTabWrapper;
